import { type TimestampUTC, type UUID } from '~/types/common';

import { fromEntries, keys, map, pipe, unique } from '@vestigas/utils';

import { type DeliveryNoteAdmin } from '../types';

import { getProcessStateChangeTimestamps } from './getProcessStateChangeTimestamps';
import { getProcessStateChangeUserIds } from './getProcessStateChangeUserIds';

/**
 * Extracts the process state changes from a delivery note.
 * @param deliveryNote - The delivery note to extract the process state changes from.
 * @returns An object with unique keys containing both user and timestamp data.
 */
export const getProcessStateChanges = (
  deliveryNote: DeliveryNoteAdmin,
): Record<string, { userId: UUID; timestamp: TimestampUTC }> => {
  const timestamps = getProcessStateChangeTimestamps(deliveryNote);
  const users = getProcessStateChangeUserIds(deliveryNote);

  const stateChanges = pipe(
    [...keys(timestamps), ...keys(users)],
    unique,
    map((key) => [
      key,
      {
        userId: users[key],
        timestamp: timestamps[key],
      },
    ]),
    fromEntries,
  );

  return stateChanges;
};
